const { onAdaReady, isAdaReady } = require('./src/index');
const { dismissAda } = require('./src/dismiss-button');
const {
  openChat,
  closeChat,
  toggleChat,
  onChatOpened,
  onChatClosed,
  onChatToggled,
  isChatOpen,
  setGreeting,
} = require('./src/chat-window');

module.exports = {
  onAdaReady,
  isAdaReady,
  dismissAda,
  openChat,
  closeChat,
  toggleChat,
  onChatOpened,
  onChatClosed,
  onChatToggled,
  isChatOpen,
  setGreeting,
};
